module.exports = __webpack_public_path__ + "static/media/giftcard.d5dbaf18.png";